<!-- 批次属性 -->
<template>
    <div v-if="componentsData.type == 22">
        <div class="overflow-hidden bg-div"
            :style="componentsData.content.version ?
                {
                    ...(componentsData.content.bg_color && { backgroundColor: componentsData.content.bg_color }),
                    ...(componentsData.content.bg_img.picview && componentsData.content.bg_value && { backgroundImage: `url(${componentsData.content.bg_img.picview})` }),
                    padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                    margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                    borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`
                } : 
                `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
            "
        >
            <div class="flex-c header-pb" v-if="componentsData.content.style_value == 1"
                :style="`border-bottom: 1px solid ${componentsData.content.headline_border_color};
                    background: ${componentsData.content.headline_bg_color}; font-size: ${componentsData.content.headline_size}px; color: ${componentsData.content.headline_color};
                `"
            >
                <div class="dec-left" :style="{ background: decLeft }"></div>
                <div class="dec-content fw-bold"> {{ componentsData.content.headline }} </div>
                <div class="dec-right" :style="{ background: decRight }"></div>
            </div>
            <div v-else class="header-pb fw-bold"
                :style="`text-align: ${componentsData.content.headline_position};border-bottom: 1px solid ${componentsData.content.headline_border_color};
                    background: ${componentsData.content.headline_bg_color}; font-size: ${componentsData.content.headline_size}px; color: ${componentsData.content.headline_color};
                `"
            >
                {{ componentsData.content.headline }}
            </div>
            <div class="pt-6">
                <div :style="`font-size: ${componentsData.content.title_size}px; color: ${componentsData.content.title_color};`">内容标题</div>
                <div class="txt-div">
                    <div :style="`color: ${componentsData.content.text_name_color};font-size: ${componentsData.content.text_name_size}px;`" >
                        批次名称：
                    </div>
                    <div :style="`color: ${componentsData.content.text_color};font-size: ${componentsData.content.text_size}px;`" >
                        批次内容
                    </div>
                </div>
                <div class="txt-div">
                    <div :style="`color: ${componentsData.content.text_name_color};font-size: ${componentsData.content.text_name_size}px;`" >
                        批次名称：
                    </div>
                    <div :style="`color: ${componentsData.content.text_color};font-size: ${componentsData.content.text_size}px;`" >
                        批次内容
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        decLeft() {
            return `linear-gradient(to left, ${this.componentsData.content.dec_color}, transparent)`;
        },
        decRight() {
            return `linear-gradient(to right, ${this.componentsData.content.dec_color}, transparent)`;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.form-container {
    margin: 0 24px;
}
.text-container {
    padding: 0 12px 12px 12px;
    background-color: hsla(0, 0%, 88.2%, 0.67) !important;
}
.text-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid rgb(0, 159, 194);
}
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-content {
    max-width: 200px;
    white-space: nowrap; /* 确保文本不会换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.header-pb {
    padding-bottom: 6px;
}
.pt-6 {
    padding-top: 6px;
}
.txt-div {
    padding: 6px 0 0 0; 
    display: flex;
}
.fw-bold {
    font-weight: bold;
}
</style>